// Anonymous "Follow my team" push for the public hub (no account needed).
import { api } from "./chalkApi";
import { isPushSupported } from "./push";
import { publicFollow, publicUnfollow } from "./tournamentApi";

const KEY = (slug) => `chalkos.follows.${slug}`;

export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent || "") && !window.MSStream;
}

export function isStandalone() {
  return window.matchMedia?.("(display-mode: standalone)").matches || Boolean(navigator.standalone);
}

export function followSupport() {
  if (isIOS() && !isStandalone()) return "ios_needs_home_screen";
  return isPushSupported() ? "ok" : "unsupported";
}

export function followedTeams(slug) {
  try { return JSON.parse(localStorage.getItem(KEY(slug)) || "[]"); } catch { return []; }
}

function save(slug, ids) {
  localStorage.setItem(KEY(slug), JSON.stringify(ids));
}

function b64ToBytes(b64) {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = window.atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}

async function subscription() {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications are blocked for this site.");
  const { public_key: vapid } = await api.pushVapidPublicKey();
  if (!vapid) throw new Error("Alerts aren't configured yet.");
  const reg = await navigator.serviceWorker.ready;
  return (await reg.pushManager.getSubscription())
    || reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(vapid) });
}

export async function followTeam(slug, teamId) {
  const json = (await subscription()).toJSON();
  await publicFollow(slug, { team_id: teamId, endpoint: json.endpoint, keys: json.keys });
  const ids = Array.from(new Set([...followedTeams(slug), teamId]));
  save(slug, ids);
  return ids;
}

export async function unfollowTeam(slug, teamId) {
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) await publicUnfollow(slug, { team_id: teamId, endpoint: sub.endpoint });
  const ids = followedTeams(slug).filter((x) => x !== teamId);
  save(slug, ids);
  return ids;
}
